module.exports = __webpack_public_path__ + "static/media/supercar.b62fe4e2.svg";